import { useState } from 'react';
import { useSelector } from 'react-redux';

import {
  Accordion,
  AccordionItem,
  AccordionPanel,
  AccordionButton,
  Box,
  useBreakpointValue,
  type AccordionProps,
} from '@frontend/components';

import { CadTree, CadTreeSearch } from 'modules/common/viewer/cadViewer/cadTab';

import { getActiveRootFileUuid } from '../data/reducer';

export type HasTransform = {
  transform?: {
    x: number;
    y: number;
  };
};

//Warning: The css in this is challenging (Stuart and Alex Taxera helped).
//In order to constrain the Accordian height get the scroll bar placed correctly on the
//CadTree, we needed to force the components to render with flex
const FileViewerCadTree = ({
  parentHeight,
  ...props
}: AccordionProps & { parentHeight: number }) => {
  const isMobile = useBreakpointValue(
    {
      base: true,
      tablet: true,
      desktop: false,
    },
    { ssr: false },
  );
  const [isAccordianOpen, setIsAccordianOpen] = useState<boolean>(
    isMobile ? false : true,
  );
  const activeRootFileUuid = useSelector(getActiveRootFileUuid);

  const cadTreeTitleHeight = 44;
  const cadTreeSearchHeight = 40;
  const cadTreeSpacing = 44;
  const cubeOffset = 160;
  const maxCadTreeHeight =
    parentHeight -
    cadTreeTitleHeight -
    cadTreeSearchHeight -
    cadTreeSpacing -
    cubeOffset;

  return (
    <Accordion
      position="absolute"
      display="flex"
      paddingRight={0}
      minWidth={38}
      width={38}
      zIndex={5}
      allowMultiple={false}
      index={isAccordianOpen ? 0 : -1}
      maxHeight={`calc(100% - ${cubeOffset}px)`}
      overflow="hidden"
      {...props}
    >
      <AccordionItem
        display="flex"
        overflow="hidden"
        flex="1 1 auto"
        flexDirection="column"
        {...(isAccordianOpen && {
          sx: {
            '.chakra-collapse': {
              display: 'flex !important',
              flexDirection: 'column',
              flex: '1 1 auto',
            },
          },
        })}
      >
        <AccordionButton
          flexShrink={0}
          onClick={() => {
            setIsAccordianOpen(!isAccordianOpen);
          }}
        >
          CAD Tree
        </AccordionButton>
        <AccordionPanel
          display="flex"
          flexDirection="column"
          flex="1 1 auto"
          paddingX={0}
          pb={0}
          overflow="hidden"
        >
          <CadTreeSearch />
          <Box flex="0 1 auto" overflow="hidden">
            <CadTree
              partFileUuid={activeRootFileUuid}
              partHasSupportingFiles={false}
              maxCadTreeHeight={maxCadTreeHeight}
            />
          </Box>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
};

export default FileViewerCadTree;
